import React from 'react'
import Notification from '../../components/App/Notification';
import SideNavBar from './SideNavBar';

function PageWrapper({ children, className, style, navbar, title, subtitle }) {
  const defaultFont = 'text-gray-600';
  return (
    <div className={`relative min-h-screen ${defaultFont} bg-light relative overflow-x-hidden ${className}`} style={style}>
      <Notification/>
      {navbar && 
      <SideNavBar title={title} subtitle={subtitle}>
        { children }
      </SideNavBar>}
      {!navbar && 
        children  
      }
    </div>
  )

}

export default PageWrapper
